import React, { useState } from 'react';

const Conclusion = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleNextPage = () => setCurrentPage(currentPage + 1);
  const handlePreviousPage = () => setCurrentPage(currentPage - 1);

  return (
    <div>
      {currentPage === 1 && (
        <PageOne onNext={handleNextPage} />
      )}
      {currentPage === 2 && (
        <PageTwo onPrevious={handlePreviousPage} onNext={handleNextPage} />
      )}
      {currentPage === 3 && (
        <PageThree onPrevious={handlePreviousPage} />
      )}
    </div>
  );
};

const PageOne = ({ onNext }) => (
  <div>
    <h2 className="text-4xl font-bold text-black mb-5">
  Conclusion And<span className="text-[#680099] ml-2 font-bold">Investor Engagement</span>
</h2>

    <p style={{ fontSize: '19px' }}>
      Vigovia Travel Technologies Pvt Ltd presents an attractive investment opportunity, with a proven product, scalable business model, and strategic growth plans in both the B2B and B2C markets. This funding round will fuel Vigovia's trajectory toward becoming a leading travel and forex platform in India and UAE.
    </p>

    {/*<button onClick={onNext} style={paginationButtonStyle}>Next</button>*/}
  </div>
);

const PageTwo = ({ onPrevious, onNext }) => (
  <div>
    <h2 className="text-4xl font-bold text-black mb-5">
  Projected Returns And<span className="text-[#680099] ml-2 font-bold">Comparisons</span>
</h2>
    

      {/* Projected Returns and Comparison Content */}
      <ol style={{color: '#321e5d'}}>
        <li style={{fontSize: '19px'}}> <strong> Dividend Based Return on Investment (3-Year Projection)</strong>
        <p style={{fontSize:'17px'}}> For an investor contributing <strong>₹1.65 crore</strong> (5.5% equity), here are the projected dividends based on Vigovia's growth and profit distribution model, with 30% of net profits allocated for dividends.

        </p>

      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle2}>
          <div style={boxHeadingStyle}>Year</div>
          <p style={boxContentStyle}> 1 </p>
          <p style={leftboxContentStyle}> 2 </p>
          <p style={leftboxContentStyle}> 3 </p>
          <p style={leftboxContentStyle}> <strong> Total </strong></p>


        </div>

        <div style={leftBoxStyle1}>
          <div style={boxHeadingStyle}>Net Profit</div>
          <p style={boxContentStyle}> ₹65 Lakhs</p>
          <p style={leftboxContentStyle}> ₹1.04 Crore</p>
          <p style={leftboxContentStyle}> ₹1.72 Crore</p>

        </div>

        <div style={midBoxStyle2}>
          <div style={boxHeadingStyle}>Dividend Pool</div>
          <p style={boxContentStyle}> ₹19.5 Lakhs</p>
          <p style={leftboxContentStyle}> ₹31.2 Lakhs</p>
          <p style={leftboxContentStyle}> ₹51.6 Lakhs</p>

        </div>

        <div style={rightBoxStyle2}>
          <div style={boxHeadingStyle}>Investor's Dividend (5.5%)</div>
          <p style={boxContentStyle}> ₹1.07 Lakhs</p>
          <p style={leftboxContentStyle}> ₹1.72 Lakhs</p>
          <p style={leftboxContentStyle}> ₹2.84 Lakhs</p>
          <p style={leftboxContentStyle}> <strong> ₹5.63 Lakhs </strong></p>


        </div>
      </div>
        </li>
        <br />

        <li style={{fontSize: '19px'}}> <strong> 10-Year Dividend And Capital Appreciation for a ₹1,00,000 investment </strong>
        <p style={{fontSize:'17px'}}> 
            For an investor holding a 0.5% equity stake ( ₹1,00,000 investment) based on Vigovia's 3-% dividend payout policy, here is the projected return on onvestment over 10 years. 

        </p>
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle3}>
          <div style={boxHeadingStyle}>Year</div>
          <p style={boxContentStyle}> 1 </p>
          <p style={leftboxContentStyle}> 2 </p>
          <p style={leftboxContentStyle}> 3 </p>
          <p style={leftboxContentStyle}> 4 </p>
          <p style={leftboxContentStyle}> 5 </p>
          <p style={leftboxContentStyle}> 6 </p>
          <p style={leftboxContentStyle}> 7 </p>
          <p style={leftboxContentStyle}> 8 </p>
          <p style={leftboxContentStyle}> 9 </p>
          <p style={leftboxContentStyle}> 10 </p>

          <p style={leftboxContentStyle}> <strong> Total Dividend Return </strong></p>


        </div>

        <div style={leftBoxStyle1}>
          <div style={boxHeadingStyle}>Net Profit</div>
          <p style={boxContentStyle}> ₹65 Lakhs</p>
          <p style={leftboxContentStyle}> ₹1.04 Crore</p>
          <p style={leftboxContentStyle}> ₹1.72 Crore</p>
          <p style={leftboxContentStyle}> ₹2.58 Crore</p>
          <p style={leftboxContentStyle}> ₹3.87 Crore</p>
          <p style={leftboxContentStyle}> ₹5.8 Crore</p>
          <p style={leftboxContentStyle}> ₹8.7 Crore</p>
          <p style={leftboxContentStyle}> ₹13 Crore</p>
          <p style={leftboxContentStyle}> ₹19.5 Crore</p>
          <p style={leftboxContentStyle}> ₹29 Crore</p>

        </div>

        <div style={midBoxStyle2}>
          <div style={boxHeadingStyle}>Dividend Pool</div>
          <p style={boxContentStyle}> ₹19.5 Lakhs</p>
          <p style={leftboxContentStyle}> ₹31.2 Lakhs</p>
          <p style={leftboxContentStyle}> ₹51.6 Lakhs</p>
          <p style={leftboxContentStyle}> ₹77.4 Lakhs</p>
          <p style={leftboxContentStyle}> ₹1.16 Crore</p>
          <p style={leftboxContentStyle}> ₹1.74 Crore</p>
          <p style={leftboxContentStyle}> ₹2.61 Crore</p>
          <p style={leftboxContentStyle}> ₹3.9 Crore</p>
          <p style={leftboxContentStyle}> ₹5.85 Crore</p>
          <p style={leftboxContentStyle}> ₹8.7 Crore</p>





        </div>

        <div style={rightBoxStyle2}>
          <div style={boxHeadingStyle}>Investor's Dividend (5.5%)</div>
          <p style={boxContentStyle}> ₹9,750</p>
          <p style={leftboxContentStyle}> ₹15,600</p>
          <p style={leftboxContentStyle}> ₹25,800</p>
          <p style={leftboxContentStyle}> ₹38,700</p>
          <p style={leftboxContentStyle}> ₹58,200</p>
          <p style={leftboxContentStyle}> ₹87,000</p>
          <p style={leftboxContentStyle}> ₹1,30,500</p>
          <p style={leftboxContentStyle}> ₹1,95,000</p>
          <p style={leftboxContentStyle}> ₹2,92,500</p>
          <p style={leftboxContentStyle}> ₹4,35,000</p>

          <p style={leftboxContentStyle}> <strong> ₹12,88,050 </strong></p>


        </div>
      </div>
        

        <br />
        <p style={{fontSize: '19px'}}> <strong> Capital Appreciation Over 10 Years </strong></p>

          <p style={{fontSize:'17px'}}> 
              Assuming a 20% annual growth in company valuation, here's how a ₹1,00,000 investment would appreciate over 10 yeras:

          </p>
          <div style={boxesContainerStyle}>
            {/* Left box */}
            <div style={leftBoxStylethree}>
              <div style={boxHeadingStyle}>Year</div>
              <p style={boxContentStyle}> 1 </p>
              <p style={leftboxContentStyle}> 2 </p>
              <p style={leftboxContentStyle}> 3 </p>
              <p style={leftboxContentStyle}> 4 </p>
              <p style={leftboxContentStyle}> 5 </p>
              <p style={leftboxContentStyle}> 6 </p>
              <p style={leftboxContentStyle}> 7 </p>
              <p style={leftboxContentStyle}> 8 </p>
              <p style={leftboxContentStyle}> 9 </p>
              <p style={leftboxContentStyle}> 10 </p>

            </div>

            <div style={leftBoxStylethree1}>
              <div style={boxHeadingStyle}>Projected Valuation (₹ Crore) </div>
              <p style={boxContentStyle}> 30 </p>
              <p style={leftboxContentStyle}> 36 </p>
              <p style={leftboxContentStyle}> 43.2 </p>
              <p style={leftboxContentStyle}> 51.8 </p>
              <p style={leftboxContentStyle}> 62.2 </p>
              <p style={leftboxContentStyle}> 74.6 </p>
              <p style={leftboxContentStyle}> 89.5 </p>
              <p style={leftboxContentStyle}> 107.4 </p>
              <p style={leftboxContentStyle}> 128.9 </p>
              <p style={leftboxContentStyle}> 154.7 </p>

            </div>

            <div style={midBoxStyleright}>
              <div style={boxHeadingStyle}>Value of 0.5% Equity (₹)</div>
              <p style={boxContentStyle}> 1,00,000</p>
              <p style={leftboxContentStyle}> 1,20,000</p>
              <p style={leftboxContentStyle}> 1,44,000 </p>
              <p style={leftboxContentStyle}> 1,73,000 </p>
              <p style={leftboxContentStyle}> 2,07,500 </p>
              <p style={leftboxContentStyle}> 2,49,000 </p>
              <p style={leftboxContentStyle}> 2,99,000 </p>
              <p style={leftboxContentStyle}> 3,59,000 </p>
              <p style={leftboxContentStyle}> 4,31,000 </p>
              <p style={leftboxContentStyle}> 5,17,000 </p>





            </div>

          </div>
          <p style={{ fontSize: "17px"}}> <strong> Capital Appreciation:</strong> ₹ 4,17,000 over 10 years on an intial ₹1,00,000 investment.</p>
          <p><strong>Total Return on Investment Over 10 Years</strong></p>
          <div style={boxesContainerStyle}>
            {/* Left box */}
            <div style={leftBoxStylethree22}>
              <div style={boxHeadingStyle}>Component</div>
              <p style={boxContentStyle}> Total Dividends </p>
              <p style={leftboxContentStyle}> Capital Appreciation</p>
              <p style={leftboxContentStyle}> <strong> Total Return</strong></p>
            </div>

            <div style={rightboxstyel22}>
              <div style={boxHeadingStyle}> Amount (₹) </div>
              <p style={boxContentStyle}> ₹ 12,88,050 </p>
              <p style={leftboxContentStyle}> ₹4,17,000 </p>
              <p style={leftboxContentStyle}> <strong> ₹ 17,05,050</strong></p>
            </div>

          </div>
          <p style={{ fontSize: "16px"}}> For a ₹1,00,000 investment, the total return over 10 years is approximately ₹17,05,050, representing a 170.5% return on the intial investment.</p>
        </li>
        <br />

        <li style={{fontSize: '19px'}}> <strong> Annualized Return Comparison with Other Investment Options</strong>

          <div style={boxesContainerStyle}>
            {/* Left box */}
            <div style={slleftBoxStyle2}>
              <div style={boxHeadingStyle}>Investment Options</div>
              <p style={boxContentStyle}> Fixed Depoists (FD) </p>
              <p style={leftboxContentStyle}> Government Bonds </p>
              <p style={leftboxContentStyle}> Equity Mutual Funds </p>
              <p style={leftboxContentStyle}> Blue Chip Stocks </p>
              <p style={leftboxContentStyle}> Growth/Small Cap Stocks </p>
              <p style={leftboxContentStyle}> Real State </p>
              <p style={leftboxContentStyle}> Vigovia Investment </p>
            </div>

            <div style={leftBoxStyle1}>
              <div style={boxHeadingStyle}>Annualized Returns</div>
              <p style={boxContentStyle}> 5-7 % </p>
              <p style={leftboxContentStyle}> 6-8 % </p>
              <p style={leftboxContentStyle}> 10-15 % </p>
              <p style={leftboxContentStyle}> 10-12 % </p>
              <p style={leftboxContentStyle}> 15-20 % </p>
              <p style={leftboxContentStyle}> 8-12 % </p>
              <p style={leftboxContentStyle}> 170.5% </p>
            </div>

            <div style={midBoxStyle2}>
              <div style={boxHeadingStyle}>Risk Level</div>
              <p style={boxContentStyle}> Low </p>
              <p style={leftboxContentStyle}>Low To Medium </p>
              <p style={leftboxContentStyle}> Medium </p>
              <p style={leftboxContentStyle}> Medium </p>
              <p style={leftboxContentStyle}> High </p>
              <p style={leftboxContentStyle}> Medium To High </p>
              <p style={leftboxContentStyle}> High </p>

            </div>

            <div style={rightBoxStyle2}>
              <div style={boxHeadingStyle}>Investment Horizon</div>
              <p style={boxContentStyle}> Short To Medium Term </p>
              <p style={leftboxContentStyle}> Medium To Long Term</p>
              <p style={leftboxContentStyle}> Medium To Long Term</p>
              <p style={leftboxContentStyle}> Long Term</p>
              <p style={leftboxContentStyle}> Long Term</p>
              <p style={leftboxContentStyle}> Long Term</p>
              <p style={leftboxContentStyle}> Long Term (10 Years) </p>

            </div>
          </div>

          <p style={{fontSize:'19px', marginTop: '30px',marginLeft: '10px'}}> <strong>Investment Comparison Highlights</strong></p>
            <ul style={{ fontSize: '18px', marginBottom: "10px"}}>
              <li style={{ marginBottom: "10px"}}>
                <strong>Vigovia vs. Fixed Deposits (FDs):</strong> FD returns (5-7%) are significantly lower than Vigovia's projected 170.5%, but FDs offer capital security and suit conservative investors.
              </li>

              <li style={{ marginBottom: "10px"}}>
                <strong>Vigovia vs. Government Bonds:</strong> Bonds provide predictable, low-risk returns (6-8%). In contrast, Vigovia offers higher growth potential for those willing to embrace moderate risk.
              </li>
              <li style={{ marginBottom: "10px"}}>
                <strong>Vigovia vs. Mutual Funds and Stocks:</strong> While equity mutual funds and stocks offer 10-20% returns, Vigovia's returns outshine these options, appealing to growth-focused investors.
              </li>
              <li style={{ marginBottom: "10px"}}>
                <strong>Vigovia vs. Real Estate:</strong> Real estate returns (8-12%) require high capital and provide moderate gains. Vigovia's high-growth, low-entry investment structure is an appealing alternative.
              </li>
            </ul>
        </li>


    </ol>

    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
      <button onClick={onPrevious} style={paginationButtonStyle}>Previous</button>
      <button onClick={onNext} style={paginationButtonStyle}>Next</button>
    </div>
  </div>
);

const PageThree = ({ onPrevious }) => (
  <div>

<h2 className="text-4xl font-bold text-black mb-5">
  Final Thoughts And<span className="text-[#680099] ml-2 font-bold">Conclusions</span>
</h2>
    
    <p style={{ fontSize: '19px' , marginBottom:'5px'}}>
      For portfolio diversification, Vigovia enables investors to gain exposure to the travel technology and forex market while balancing with secure investments, thus providing an optimal blend of high returns and strategic portfolio growth.
    </p>

    <ol>
      <li style={{ fontSize: '18px', marginBottom:'5px'}}> <strong>Revenue-Based Valuation</strong>
      <p style={{fontSize: '17px'}}>The Price-to-Sales (P/S) ratio is commonly used for startups and companies with high growth
          potential, especially in the tech and travel sectors. For high-growth travel tech companies, a P/S ratio
          of 4-5x is typical.
      </p>
      <ul>
        <li style={{fontSize: '17px'}}>Current Annual Revenue (Organic, B2B only): ₹1 crore</li>
        <li style={{fontSize: '17px', marginBottom:'15px'}}>Projected Revenue (Year 3, with B2B and B2C): ₹8.64 crore</li>
      </ul>

      <p style={{ marginLeft:'13px'}}> <strong>Using the projected revenue: </strong></p>
      <div style={boxesContainerStyle}>
        {/* Left box */}
        
        <div style={page3leftBoxStyle}>
          <div style={boxHeadingStyle}>Metric</div>
          <p style={boxContentStyle}> Lower P/S Ratio (4x)</p>
          <p style={leftboxContentStyle}> Upper P/S Ratio (6x)</p>
          <p style={leftboxContentStyle}>Selected Valuation (Conservative)</p>

        </div>

        <div style={page3midBoxStyle2}>
          <div style={boxHeadingStyle}>Calculation</div>
          <p style={boxContentStyle}> ₹ 8.64 Crore X 4 </p>
          <p style={leftboxContentStyle}> ₹ 8.64 Crore X 6 </p>
          <p style={leftboxContentStyle}> ₹ 30 Crore (On Year 1 Baseline)</p>

        </div>

        <div style={page3rightBoxStyle2}>
          <div style={boxHeadingStyle}>Valuation ( ₹ Crore)</div>
          <p style={boxContentStyle}> ₹ 34.56 Crore</p>
          <p style={leftboxContentStyle}> ₹ 51.84 Crore</p>
         

        </div>
      </div>
      <p style={{fontSize: '17px', marginTop: '5px'}}>This approach shows that, with anticipated growth, a  ₹30 crore valuation is conservative and could be justified even at higher multiples if revenue grows as expected.
      </p>


      </li>

      <li style={{ fontSize: '18px',marginBottom: '17px'}}> <strong>Market Growth and Demand Factors</strong>
      <p>
      <ul>
          <li style={{ fontSize: '17px', marginBottom: '15px'}}> <strong> India and UAE Travel Market Growth: </strong> Both Markets are experiencing rapid growth in digital travel and online booking, with travel technology solutions in high demand. This growth supports higher than average valuations for tech enabled travel companies.</li>
          <li style={{ fontSize: '17px'}}> <strong>  Dual B2B and B2C Model: </strong> Combining B2B and B2C allows for diversified revenue streams and high scalability, which are attractive factors to investors and could command a higher valuation
          </li>

        </ul>

      </p>
        
      </li>

      <li style={{ fontSize: '18px',marginBottom: '15px'}}> <strong>Valuation Based on Industry Comparables</strong>
        <p>
        <p style={{ marginLeft:'5px', fontSize: '17px'}}> Looking at similar companies</p>

        <ul>
            <li style={{ fontSize: '17px', marginBottom: '15px'}}> <strong>Emerging Travel Tech Companies: </strong> Companies with similar B2B or hybrid models often attract valuations of 4-6x revenue in growth stages, especially with demonstrated product-market fit and active market demand.
            </li>
            <li style={{ fontSize: '17px'}}> <strong> Forex and Additional Services Potential:  </strong>With plans to offer forex, Vigovia has the potential to expand revenue sources, supporting an upward revision in valuation as the business matures.
            </li>

          </ul>

        <p style={{ marginLeft:'5px', fontSize: '17px'}}> Given that Vigovia already has organic revenue of ₹1 crore, is expanding both B2B and B2C operations, and anticipates achieving ₹8.64 crore in revenue within three years, the valuation of ₹20 crore aligns with growth potential.
        </p>


      </p>
        
      </li>

      <li style={{ fontSize: '18px',marginBottom: '15px'}}> <strong>Potential for Future Rounds and Upside for Investors</strong>
        <p>
        <p style={{ marginLeft:'5px', fontSize: '17px'}}> The valuation allows room for Vigovia to attract further investment rounds while increasing in value. A conservative valuation at ₹30 crore ensures:
        </p>

        <ul>
            <li style={{ fontSize: '17px', marginBottom: '15px'}}> <strong>Fair Entry Point for Investors:</strong> Early-stage investors can benefit from initial equity appreciation if growth targets are met or exceeded.

            </li>
            <li style={{ fontSize: '17px'}}> <strong>Future Rounds Potential: </strong>As Vigovia scales, the valuation can support subsequent funding rounds, helping sustain growth without over-leveraging early equity.
            </li>

          </ul>
        </p>
          
      </li>
    </ol>

    <p style={{ fontSize: '19px'}}> <strong>Conclusion</strong></p>
    <p> A <strong>₹30 Crore valuation is fair and conservative </strong> given Vigovia's revenue trajectory, industry growth and scalability through both B2B and B2C channels. 
    This valuation reflects a realistic growth outlook, providing value for investors and room for further appreciation as the company achieves its projected revenue milestones.</p>

    <button onClick={onPrevious} style={paginationButtonStyle}>Previous</button>
  </div>
);

const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};


const leftBoxStyle2 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '10%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const slleftBoxStyle2 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '30%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const leftBoxStyle3 = {
    flex: 1,  // Takes up available space, but narrower due to specific width
    maxWidth: '15%',  // Adjust width to make it narrower
    backgroundColor: '#fbf4ff',  // Background color for the box
    borderRadius: '30px',
    padding: '0px',
  
  };

  const leftBoxStylethree = {
    flex: 1,  // Takes up available space, but narrower due to specific width
    maxWidth: '20%',  // Adjust width to make it narrower
    backgroundColor: '#fbf4ff',  // Background color for the box
    borderRadius: '30px',
    padding: '0px',
  
  };

  const leftBoxStylethree22 = {
    flex: 1,  // Takes up available space, but narrower due to specific width
    maxWidth: '30%',  // Adjust width to make it narrower
    backgroundColor: '#fbf4ff',  // Background color for the box
    borderRadius: '30px',
    padding: '0px',
  
  };

const leftBoxStyle1 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '30%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const page3leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '33.33%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const rightboxstyel22 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '70%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const leftBoxStylethree1 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '40%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};
  
const midBoxStyle2 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '30%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

  
};

const page3midBoxStyle2 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '33.33%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

  
};

const midBoxStyleright = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '40%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

  
};

const rightBoxStyle2 = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '30%',  // Adjust width to make it narrower

};

const page3rightBoxStyle2 = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '33.33%',  // Adjust width to make it narrower

};
const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginBottom:'20px'
};


const leftboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
};

const paginationButtonStyle = {
  marginTop: '20px',
  padding: '10px 20px',
  fontSize: '16px',
  borderRadius: '5px',
  backgroundColor:'#321E5D',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
};

export default Conclusion;